import { useEffect } from "react";
import { useSiteSettings } from "@/lib/settings";
import { resolveImage } from "@/lib/api";

// Swap the browser favicon + apple-touch-icon to the uploaded logo when present.
export default function FaviconSwapper() {
  const settings = useSiteSettings();
  useEffect(() => {
    if (!settings?.logo_path) return;
    const href = resolveImage(settings.logo_path);
    const ensure = (rel) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };
    ensure("icon");
    ensure("apple-touch-icon");
  }, [settings?.logo_path]);
  return null;
}
